import React, { Component } from 'react'

class RegisterPage extends Component {
  state = {
  }
  render() {
    return (
      <div>

      </div>
    )
  }
}

export default RegisterPage
